import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

const serviceAreas = [
  { name: "Arvada", slug: "arvada" },
  { name: "Aurora", slug: "aurora" },
  { name: "Capitol Hill", slug: "capitol-hill" },
  { name: "Centennial", slug: "centennial" },
  { name: "Central Park", slug: "central-park" },
  { name: "Cherry Creek", slug: "cherry-creek" },
  { name: "Cherry Hills", slug: "cherry-hills" },
  { name: "Columbine", slug: "columbine" },
  { name: "Commerce City", slug: "commerce-city" },
  { name: "Denver", slug: "denver" },
  { name: "DTC", slug: "dtc" },
  { name: "Edgewater", slug: "edgewater" },
  { name: "Englewood", slug: "englewood" },
  { name: "Glendale", slug: "glendale" },
  { name: "Golden", slug: "golden" },
  { name: "Greenwood Village", slug: "greenwood-village" },
  { name: "Highlands", slug: "highlands" },
  { name: "Highlands Ranch", slug: "highlands-ranch" },
  { name: "Ken Caryl", slug: "ken-caryl" },
  { name: "Lakewood", slug: "lakewood" },
  { name: "Littleton", slug: "littleton" },
  { name: "RiNo", slug: "rino" },
  { name: "Wash Park", slug: "wash-park" },
  { name: "Wheat Ridge", slug: "wheat-ridge" }
];

const ServiceAreasSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <MapPin className="h-8 w-8 text-primary" />
            <h2 className="text-3xl md:text-4xl font-bold">Areas We Serve Across Denver</h2>
          </div>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            We bring our grooming van right to your doorstep — from Cherry Creek to Highlands Ranch and beyond.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 justify-items-center [&>*:nth-last-child(-n+4)]:xl:col-span-1 xl:[&>*:nth-last-child(-n+4)]:justify-self-center">
          {serviceAreas.map((area) => (
            <Button
              key={area.slug}
              variant="outline"
              asChild
              className="h-auto py-3 px-4 hover:bg-primary hover:text-primary-foreground transition-all duration-300 w-full"
            >
              <Link to={`/locations/${area.slug}`}>
                {area.name}
              </Link>
            </Button>
          ))}
        </div>

        <div className="mt-12 max-w-2xl mx-auto">
          <div className="bg-muted/50 rounded-lg p-8 text-center">
            <h3 className="text-xl font-semibold mb-3">Not sure if we serve your area?</h3>
            <p className="text-muted-foreground mb-6">
              We're constantly expanding! Text us your ZIP code and we'll let you know.
            </p>
            <Button 
              asChild
              className="bg-primary hover:bg-primary/90"
            >
              <a href="sms:+1-720-555-0123?body=Hi! I'm interested in mobile grooming. Do you serve my area?  My ZIP code is: ">
                📱 Text Us Your Location
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;